function Slick() {
    var self = this;
	this.init();
}

Slick.prototype.init = function() {
	var that = this;

    that.mq = /\w+/g.exec(window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content'))[0];

    $('.product-gallery-carousel-wrapper').each(function(){
        that.createGalleryThumbSliders($(this));
    });

    $('.product-gallery-image').each(function(){
        that.createGalleryMainSlider($(this));
    });

    $('.catalogue-carousel-body--activate').each(function(){
        that.createCatalogueCarousel($(this));
    });

    $('.news-carousel-body').each(function(){
        that.createNewsCarousel($(this));
    });
 
    $('.section-gallery--carousel .section-gallery-wrapper').each(function(){
        that.createGalleryCarousel($(this));
    });

    that.createThumbnailsCarousel($('.pswp__thumbnails'));

    that.createBannerCarousel($('.banner-images'));
};

Slick.prototype.createGalleryCarousel = function(slider) {
    var self = this;
    var items = slider.find('.section-gallery-item').length;

    if (items >= 3) {

        // $(slider).on('init', function(e, slick) {
        //     var slides = $(slider).find('.slick-slide').length;
        //     if (slides > 6) {
        //         setTimeout(function() {
        //             $(slider).slick('slickSetOption', 'dots', 'false', true);
        //             $(slider).closest('.section-gallery--carousel').find('.-arrow').removeClass('-hidden');
        //         }, 500);
        //     }
        // });

        $(slider).siblings('.-arrow.-prev').on('click touchstart', function() {
            $(slider).slick('slickPrev');
        });

        $(slider).siblings('.-arrow.-next').on('click touchstart', function() {
            $(slider).slick('slickNext');
        });

        if (self.mq == "small") {
            $(slider).slick({
                infinite: true,
                autoplay: false,
                accessibility: false,
                swipe: true,
                verticalSwipe: true,
                swipeToSlide: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
                adaptiveHeight: false,
                waitForAnimate: false,
                fade: false,
                arrows: false,
                cssEase: 'cubic-bezier(0,0,0,1)',
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        variableWidth: false,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: 'unslick'
                    }
                ]
            });
        }
    }
};

Slick.prototype.createThumbnailsCarousel = function(slider, reinit) {
    var self = this;

    if (reinit) {
        $(slider).slick('reinit');
    } else {
        $(slider).slick({
            infinite: false,
            autoplay: false,
            accessibility: true,
            swipe: false,
            verticalSwipe: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 8,
                        slidesToScroll: 8,
                    }
                }
            ],
            swipeToSlide: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            fade: false,
            arrows: true,
            prevArrow: $(slider).siblings('.slick-arrow.-prev'),
            nextArrow: $(slider).siblings('.slick-arrow.-next'),
            cssEase: 'cubic-bezier(0,0,0,1)',
            dots: false
        });
    }
};

Slick.prototype.createBannerCarousel = function(slider) {
    var self = this;
    var slides;

    $(slider).on('init', function() {
        $(slider).siblings('.banner-nav--left').addClass('-disabled');
        slides = $(slider).find('.slick-slide').length; 
    });

    $(slider).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        accessibility: true,
        swipe: true,
        verticalSwipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        fade: false,
        arrows: false,
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: true
    });

    $(slider).on('afterChange', function(currentSlide) {
        var toShow = $(slider).slick('slickGetOption', 'slidesToShow');

        if (currentSlide.currentSlide != 0) {
            $(slider).siblings('.banner-nav--left').removeClass('-disabled');
        } else {
            $(slider).siblings('.banner-nav--left').addClass('-disabled');
        }

        if ((currentSlide.currentSlide + toShow - 1) != (slides - 1)) {
            $(slider).siblings('.banner-nav--right').removeClass('-disabled');
        } else {
            $(slider).siblings('.banner-nav--right').addClass('-disabled');
        }
    });

    $(slider).siblings('.banner-nav--left').on('click', function() {
        $(slider).slick('slickPrev');
    });

    $(slider).siblings('.banner-nav--right').on('click', function() {
        $(slider).slick('slickNext');
    });

    $(slider).ready(function() {
        $('.slick-dots').attr('aria-describedby', 'banner-images');
        $('.slick-dots').attr('aria-controls', 'banner-images');
    });
};

Slick.prototype.createGalleryThumbSliders = function(slider) {
    var self = this;
    var slides;

    $(slider).on('init', function() {
        $('.product-gallery-nav--left').addClass('-disabled');
        slides = $(slider).find('.slick-slide').length;
    });

    $(slider).slick({
        infinite: false,
        autoplay: false,
        accessibility: false,
        swipe: true,
        verticalSwipe: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: false,
        centerMode: false,
        fade: false,
        arrows: true,
        prevArrow: $(slider).siblings('.product-gallery-nav--left'),
        nextArrow: $(slider).siblings('.product-gallery-nav--right'),
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: false
    });

    // $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // $('.product-gallery-image').slick('slickGoTo', nextSlide);
    // });

    $('.product-gallery-carousel-wrapper .slick-slide').on('click', function() {
        var index = parseInt($(this).attr('data-slick-index'));
        // $(slider).slick('slickGoTo', index);
        $('.product-gallery-image').slick('slickGoTo', index);
        $('.product-gallery-carousel-wrapper').find('.product-gallery-carousel__image').removeClass('product-gallery-carousel__image--active');
        $(this).find('.product-gallery-carousel__image').addClass('product-gallery-carousel__image--active');
    });
};

Slick.prototype.createGalleryMainSlider = function(slider) {
    var self = this;
    $(slider).slick({
        infinite: false,
        autoplay: false,
        accessibility: false,
        swipe: true,
        verticalSwipe: true,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: false,
        waitForAnimate: false,
        fade: false,
        arrows: false,
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    fade: true,
                    waitForAnimate: true,
                    dots: false
                }
            }
        ]
    });
    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.product-gallery-carousel-wrapper').find('.slick-slide').removeClass('product-gallery-carousel__image--active');
        $('.product-gallery-carousel-wrapper .slick-slide[data-slick-index="'+nextSlide+'"]').addClass('product-gallery-carousel__image--active');
    });
};

Slick.prototype.createCatalogueCarousel = function(slider) {
    var self = this;
    var slides;
    var infinite = false;
    var items = parseInt($(slider).find('.catalogue-item').length);
    var itemsToShow = $(slider).attr('data-items-count') ? parseInt($(slider).attr('data-items-count')) : 4;
    var tabletCenterPadding = false;

    if ($(slider).closest('.catalogue-carousel-tabcontent').length)
        tabletCenterPadding = "20%";

    $(slider).on('init', function() {
        $(slider).siblings('.carousel-nav--left').addClass('-disabled');
        slides = $(slider).find('.slick-slide').length;
        if (slides <= 4) {
            $(slider).siblings('.carousel-nav--left').addClass('-disabled');
            $(slider).siblings('.carousel-nav--right').addClass('-disabled');
        }
    });
    if ($(slider).hasClass('catalogue-carousel--infinite'))
        infinite = true;

    if (items <= 2)
        infinite = false;

    if ($(slider).hasClass('-home')) {
        if (window.matchMedia("(min-width: 767px)").matches) {
            $(slider).slick({
                infinite: infinite,
                autoplay: false,
                accessibility: true,
                swipe: true,
                verticalSwipe: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
                waitForAnimate: false,
                variableWidth: false,
                fade: false,
                arrows: false,
                cssEase: 'cubic-bezier(0,0,0,1)',
                dots: true,
                swipeToSlide: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: itemsToShow,
                            dots: false,
                            waitForAnimate: true,
                            centerMode: false,
                            swipeToSlide: true,
                        }
                    }
                ]
            });
        }
    } else {
        $(slider).slick({
            infinite: infinite,
            autoplay: false,
            accessibility: true,
            swipe: true,
            verticalSwipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20%",
            variableWidth: false,
            waitForAnimate: false,
            fade: false,
            arrows: false,
            cssEase: 'cubic-bezier(0,0,0,1)',
            dots: true,
            swipeToSlide: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: (tabletCenterPadding)?true:false,
                        centerPadding: tabletCenterPadding,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        infinite: false,
                        centerPadding: false,
                        waitForAnimate: true,
                        slidesToShow: itemsToShow,
                        dots: false,
                        centerMode: false,
                        swipeToSlide: true,
                    }
                }
            ]
        });
    }

    $(slider).on('afterChange', function(slick, currentSlide) {
        var toShow = $(slider).slick('slickGetOption', 'slidesToShow');
        slides = $(slider).find('.slick-slide').length;

        if (currentSlide.currentSlide != 0) {
            $(slider).siblings('.carousel-nav--left').removeClass('-disabled');
        } else {
            $(slider).siblings('.carousel-nav--left').addClass('-disabled');
        }

        if ((currentSlide.currentSlide + toShow - 1) != (slides - 1)) {
            $(slider).siblings('.carousel-nav--right').removeClass('-disabled');
        } else {
            $(slider).siblings('.carousel-nav--right').addClass('-disabled');
        }
        
        if (slides <= 4) {
            $(slider).siblings('.carousel-nav--left').addClass('-disabled');
            $(slider).siblings('.carousel-nav--right').addClass('-disabled');
        }
    });

    $(slider).siblings('.carousel-nav--left').on('click', function() {
        $(slider).slick('slickPrev');
    });

    $(slider).siblings('.carousel-nav--right').on('click', function() {
        $(slider).slick('slickNext');
    });
};

Slick.prototype.createNewsCarousel = function(slider) {
    var self = this;
    var slides;

    $(slider).on('init', function() {
        $(slider).siblings('.carousel-nav--left').addClass('-disabled');
        slides = $(slider).find('.slick-slide').length;
        // if (slides <= 4) {
        //     $(slider).siblings('.carousel-nav--left').addClass('-disabled');
        //     $(slider).siblings('.carousel-nav--right').addClass('-disabled');
        // }
    });

    $(slider).slick({
        infinite: false,
        autoplay: false,
        accessibility: true,
        swipe: true,
        verticalSwipe: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        fade: false,
        arrows: false,
        cssEase: 'cubic-bezier(0,0,0,1)',
        dots: false,
        swipeToSlide: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    });

    $(slider).on('afterChange', function(slick, currentSlide) {
        var toShow = $(slider).slick('slickGetOption', 'slidesToShow');

        if (currentSlide.currentSlide != 0) {
            $(slider).siblings('.carousel-nav--left').removeClass('-disabled');
        } else {
            $(slider).siblings('.carousel-nav--left').addClass('-disabled');
        }

        if ((currentSlide.currentSlide + toShow - 1) != (slides - 1)) {
            $(slider).siblings('.carousel-nav--right').removeClass('-disabled');
        } else {
            $(slider).siblings('.carousel-nav--right').addClass('-disabled');
        }
    });

    $(slider).siblings('.carousel-nav--left').on('click', function() {
        $(slider).slick('slickPrev');
    });

    $(slider).siblings('.carousel-nav--right').on('click', function() {
        $(slider).slick('slickNext');
    });
};